import { render, staticRenderFns } from "./DialogFormFailure.vue?vue&type=template&id=376faa0c&"
import script from "./DialogFormFailure.vue?vue&type=script&lang=js&"
export * from "./DialogFormFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports